var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseChart',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.getChartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }